import styled from 'styled-components';
import { glassEffect } from '../../theme';

export const AccordionWrapper = styled.div`
  margin-bottom: 15px;
  border-radius: 12px;
  overflow: hidden;
  ${glassEffect};
  background: ${({ theme }) => theme.accordionBg}; 
`;

export const AccordionHeader = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.heading};
  font-size: 18px;
  font-weight: 600;
  
  svg {
    flex-shrink: 0; /* This prevents the icon from ever being squished or shrunk. */
    color: ${({ theme }) => theme.text};
    transition: transform 0.3s ease-in-out;
    transform: ${props => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const AccordionContent = styled.div`
  max-height: ${props => (props.$isOpen ? '2000px' : '0')};
  overflow: hidden;
  transition: max-height 0.4s ease-in-out, padding 0.4s ease-in-out;
  padding: ${props => (props.$isOpen ? '0 5px 5px 5px' : '0 0px')};
`;